import React, { useContext } from 'react'
import { AppContext } from '../../contexts/AppContext'
import InsufficientVersion from './InsufficientVersion'
import NoConnection from './NoConnection'
import ServerError from './ServerError'

interface AppStatusGuardProps {
	children: React.ReactNode
}

const AppStatusGuard: React.FC<AppStatusGuardProps> = ({ children }) => {
	const { networkConnected, serverConnectionHealthy, serverErrorMessage, sufficientVersion } =
		useContext(AppContext)

	if (!networkConnected) return <NoConnection />
	if (!serverConnectionHealthy || serverErrorMessage) return <ServerError />
	if (!sufficientVersion) return <InsufficientVersion />

	return <>{children}</>
}

export default AppStatusGuard
